import { Component, OnInit } from '@angular/core';
import { AuthService, TMAuthService } from '@fgb/core';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'fgb-tm-user-login',
  templateUrl: './tm-user-login.component.html',
  styleUrls: ['./tm-user-login.component.scss'],
})
export class TmUserLoginComponent implements OnInit {
  returnUrl: string;
  errorService: any;

  constructor(private authService: AuthService, private route: ActivatedRoute, private tmService: TMAuthService) {}

  ngOnInit() {
    this.returnUrl = this.route.snapshot.queryParams.returnUrl || '/';
  }

  loginTM() {
    this.tmService
      .login()
      .then((data: any) => {
        if (data.tokens && data.tokens.AccessToken) {
          this.authService.loginUsingToken(data.tokens.AccessToken, data.tokens.RefreshToken, this.returnUrl);
        } else {
          this.errorService.clearErrors();
          this.errorService.addError('Unable to find User.');
        }
      })
      .catch((e) => {
        this.errorService.clearErrors();
        this.errorService.addError('Invalid Email Address and Password.');
      });
  }
}
